import { CloseOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import {
  useSupportChat,
  useSupportChatEffects,
} from '@features/SupportChat/hooks';
import { Badge, Button, ConfigProvider, Tooltip } from 'antd';
import { useCallback, useState } from 'react';

import { SupportChatWindow } from './SupportChatWindow';

import '@features/SupportChat/style/SupportChat.scss';

import type { FC } from 'react';

// Попапы antd (тултипы и т.п.) по умолчанию рендерятся в body с z-index ниже,
// чем у фиксированного виджета, и прячутся за окном чата. Рендерим их внутри
// виджета — так они в его слое и поверх окна.
const getPopupContainer = (triggerNode?: HTMLElement): HTMLElement =>
  triggerNode?.closest<HTMLElement>('.SupportChatWidget') ?? document.body;

export const SupportChatWidget: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    unreadCount,
    syncMessagesScroll,
    resetChatState,
    handleClosedChatMessageEvent,
    markMessagesAsRead,
    ...windowModel
  } = useSupportChat(isOpen);

  useSupportChatEffects({
    isOpen,
    syncMessagesScroll,
    resetChatState,
    handleClosedChatMessageEvent,
    markMessagesAsRead,
  });

  const triggerLabel = unreadCount
    ? `Чат с поддержкой, непрочитанных ответов: ${unreadCount}`
    : 'Чат с поддержкой';

  const toggle = useCallback(() => setIsOpen((opened) => !opened), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <ConfigProvider getPopupContainer={getPopupContainer}>
      <div className="SupportChatWidget">
        {isOpen && <SupportChatWindow {...windowModel} onClose={close} />}

        <Tooltip title={isOpen ? null : triggerLabel} placement="left">
          <Badge count={unreadCount} overflowCount={99}>
            <Button
              className="SupportChatWidget__trigger"
              type="primary"
              shape="circle"
              size="large"
              icon={isOpen ? <CloseOutlined /> : <CustomerServiceOutlined />}
              aria-label={triggerLabel}
              aria-expanded={isOpen}
              onClick={toggle}
            />
          </Badge>
        </Tooltip>
      </div>
    </ConfigProvider>
  );
};
